// src/components/Admin/StudentHomeCmp/StudenthomeGrid.jsx (Module1)
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid, Button, Icon } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { hasText, htmlHasContent, hasItems } from "../guiaHelpers";
import "./Module1.scss";

const virtualScenesController = new VirtualScenes();

// AÑADIMOS 'pdfUrl' a las props
export function Module1({ refId, onLoadComplete, pdfUrl }) {
  const module1 = "module_01";
  const { accessToken } = useAuth();
  const { t } = useTranslation("scenes");

  const [moduleData, setModuleData] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModuleData = useCallback(async () => {
    // ... (la lógica de fetch de Module1 no cambia)
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module1,
      );
      setModuleData(data.moduleData);
      if (data.moduleData?.bannertop) {
        const bannerData = await virtualScenesController.getRepoScene(
          data.moduleData.bannertop,
          accessToken,
        );
        setBannerUrl(bannerData.url);
      }
    } catch (err) {
      console.error("Error al obtener los datos del módulo o banner:", err);
      setError(true);
    } finally {
      setLoading(false);
      if (onLoadComplete) onLoadComplete();
    }
  }, [refId, accessToken, module1, onLoadComplete]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  // Sin datos (cargando, error o modulo vacio) => no renderizamos nada.
  if (loading || error) return null;

  const {
    ModOneTitle,
    ModOneDescription,
    ModOneTags,
    ModOneCategory,
    ModOneSubcategory,
  } = moduleData || {};

  const hasContent =
    hasText(ModOneTitle) ||
    htmlHasContent(ModOneDescription) ||
    hasItems(ModOneTags) ||
    hasItems(ModOneCategory) ||
    hasItems(ModOneSubcategory) ||
    !!bannerUrl;

  if (!hasContent) return null;

  const hasCategory = hasItems(ModOneCategory) || hasItems(ModOneSubcategory);

  return (
    <div className="module1-container">
      <Grid stackable columns={2} className="module1-grid">
        <Grid.Column width={bannerUrl ? 8 : 16} className="module1-text-column">
          <div>
            {hasText(ModOneTitle) && (
              <h2 className="module1-title">{ModOneTitle}</h2>
            )}
            {htmlHasContent(ModOneDescription) && (
              <div
                className="module1-description"
                dangerouslySetInnerHTML={{ __html: ModOneDescription }}
              />
            )}
            {hasItems(ModOneTags) && (
              <div className="module1-tags">
                <p>
                  <strong>{t("guide.keywords")}</strong>
                  {ModOneTags.map((tag) => ` #${tag}`).join("")}
                </p>
              </div>
            )}
          </div>
          <div className="module1-spacer" />

          <div>
            {pdfUrl && (
              <Button
                className="module1-download-button"
                as="a"
                href={pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name="download" />
                {t("guide.context")}
              </Button>
            )}
            {hasCategory && (
              <p className="module1-category">
                {hasItems(ModOneCategory) ? ModOneCategory.join(", ") : ""}
                {hasItems(ModOneCategory) && hasItems(ModOneSubcategory)
                  ? " - "
                  : ""}
                {hasItems(ModOneSubcategory)
                  ? ModOneSubcategory.join(", ")
                  : ""}
              </p>
            )}
          </div>
        </Grid.Column>

        {bannerUrl && (
          <Grid.Column width={8} className="module1-image">
            <img
              src={bannerUrl}
              alt="Vista del módulo"
              className="module1-banner"
            />
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
}
